/** Сколько своих голосов даст подписка, если её нет и она даёт больше текущего предела; иначе null (подписка уже есть, предел неизвестен или не больше).
    По нему «Мои голоса» пишут «3 из 3 · с подпиской до 15» и на пределе зовут «Больше голосов с подпиской», как шаблон */
export function voiceOffer(o: { subscribed: boolean; limit: number | null | undefined; planVoices: number | null | undefined }): number | null {
  const { subscribed, limit, planVoices } = o;
  if (subscribed || limit == null || !Number.isFinite(limit) || planVoices == null || !(planVoices > limit)) return null;
  return planVoices;
}
